import { Outlet } from 'react-router-dom'
import Box from '@mui/material/Box'

const AuthLayout = () => (
    <Box
        sx={{
            minHeight: '100dvh',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: 2,
            py: 4,
            overflowY: 'auto',
            backgroundColor: (theme) =>
                theme.palette.mode === 'dark' ? theme.palette.background.default : '#f6f8fa'
        }}>
        <Outlet />
    </Box>
)

export default AuthLayout
